import environment from '../../../environment';
import { formatAddressResults } from '../../../shared';
import fetch from '../../fetch';
import reducers from './reducers';
import uuid from 'uuid';
import { LogActionModel } from '../../../../models/logAction.model';
import { CONFIG } from '../../../../config';

const general = (() => {
    const get = {
    };

    get.brands = req =>
        fetch({
            type: 'GET',
            async: false,
            url: `${environment.get('API_HOST')}/general/obterbandeirashabilitadas`
        }).then((res) => {
            return reducers.brands(res, req);
        });

    get.brands.client = () =>
        fetch({
            type: 'GET',
            async: false,
            url: `${environment.get('API_HOST')}/general/ObterBandeirasClientesCadastrados`
        });

    get.config = () => {
        const _error = ({message}) => {
            if(message !== "Unauthorized"){
                location.reload();
            }
        };

        return fetch({
            type: 'GET',
            async: false,
            url: `${environment.get('API_HOST')}/cliente/GetClienteConfiguracao`
        }).then(res => {
            environment.set('SESSION_ID', uuid().replace('-', ''));
            return reducers.config(res);
        }, _error);
    };

    get.geocode = req =>
        fetch({
            type: 'GET',
            async: false,
            url: `${environment.get('API_HOST')}/general/geocode`,
            data: {...req, country: window.NeoGIG.country}
        }).then(res => {
            const data = JSON.parse(res);
            return formatAddressResults(data.results[0]);
        });

    const validate = {};

    validate.captcha = req =>
        fetch({
            type: 'POST',
            async: false,
            data: JSON.stringify(req),
            url: `${environment.get('API_HOST')}/captcha/validatecaptcha`
        });

    validate.account = () =>
        fetch({
            type: 'GET',
            async: false,
            url: `${environment.get('API_HOST')}/users/sendConfirmationEmail?email=${sessionStorage.username}`
        });

    validate.acceptTermsUse = () =>
        fetch({
            type: 'POST',
            async: false,
            url: `${environment.get('API_HOST')}/users/AcceptTermsUse`
        });

    const log = {};

    log.action = (context: ContextEnum, action: string, parameters: string = '') =>
    {
      if (CONFIG.NODE_ENV.toLowerCase() !== 'production') {
        return;
      }

      if (typeof(parameters) === 'object') {
        parameters = JSON.stringify(parameters);
      }

      return fetch({
        type: 'POST',
        async: true,
        data: JSON.stringify(new LogActionModel(context, action, parameters)),
        url: `${environment.get('CTRL_PANEL_API')}/system/log`
      })
      .then(() => {});
    };

    return {
        get,
        validate,
        log
    };
})();

export default general;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/general/index.js